import React__default from 'react';

/**
 * Render a table header cell with the name of a weekday (e.g., "Mo", "Tu").
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Weekday(props) {
    return React__default.createElement("th", { ...props });
}

export { Weekday };
